import { render } from "./MySearches.vue?vue&type=template&id=132a179f&scoped=true&lang=pug"
import script from "./MySearches.vue?vue&type=script&lang=js"
export * from "./MySearches.vue?vue&type=script&lang=js"

import "./MySearches.vue?vue&type=style&index=0&id=132a179f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132a179f"]])

export default __exports__